export default {
  th: {
    contestName: "ชื่อการแข่งขัน",
    contestNamePlaceholder: "กรอกชื่อการแข่งขัน",
    contestNameSuccess: "ชื่อการแข่งขันถูกอัปเดตเรียบร้อย",
    bannerContest: {
      title: "เตรียมพบกับ: IUX Trade and Win",
      title2: "เข้าร่วม IUX Trade and Win",
      desc: "เริ่มต้นแมตช์การเทรดของคุณและแข่งขันเพื่อชิงรางวัลมูลค่า $12,000!",
      button: "เข้าร่วมทันที",
    },
    popupContest: {
      title: "เข้าร่วม \nIUX Trade and Win",
      desc: "เริ่มต้นแมตช์การเทรดของคุณและแข่งขัน\nเพื่อชิงรางวัลมูลค่า $12,000!",
      button: "เข้าร่วมทันที",
    },
    dashboardContest: {
      dashboard: "แดชบอร์ด",
      not_participate: "ไม่เข้าร่วม",
      preparing: "กำลังเตรียมการ",
      participate: "เข้าร่วม",
      deposit: "ฝากเงิน",
      return: "ผลตอบแทน",
      return_percent: "ผลตอบแทน (%)",
      prize: "รางวัล",
      top_trade: "การซื้อขายสูงสุด",
      ranking: "อันดับ",
      rank: "อันดับ",
      competitors: "ผู้เข้าแข่งขัน",
      title_no_data: "ไม่พบข้อมูล",
      desc_no_data: "การแข่งขันยังไม่ได้อัปเดต",
      title_no_ranking: "ไม่มีการจัดอันดับ",
      desc_no_ranking: "การแข่งขันยังไม่ได้เริ่มต้น",
      contest_minimum_deposit:
        "คุณต้องฝากเงินขั้นต่ำ ${value} ดอลลาร์สหรัฐก่อน",
    },
  },
  en: {
    contestName: "Profile Name",
    contestNamePlaceholder: "Enter your profile name",
    contestNameSuccess: "Profile name updated.",
    bannerContest: {
      title: "Upcoming: IUX Trade and Win",
      title2: "Join IUX Trade and Win",
      desc: "Kick Off Your Trading Match and Compete for $12,000 in Prizes!",
      button: "Join now",
    },
    popupContest: {
      title: "Join \nIUX Trade and Win",
      desc: "Kick Off Your Trading Match and Compete \nfor $12,000 in Prizes!",
      button: "Join now",
    },
    dashboardContest: {
      dashboard: "Dashboard",
      not_participate: "Not Participating",
      preparing: "Preparing",
      participate: "Participating",
      deposit: "Deposit",
      return: "Returns",
      return_percent: "Returns (%)",
      prize: "Prize",
      top_trade: "Top Trades",
      ranking: "Ranking",
      rank: "Rank",
      competitors: "Competitors",
      title_no_data: "Data not found.",
      desc_no_data: "The contest has not been updated yet.",
      title_no_ranking: "No ranking.",
      desc_no_ranking: "The contest has not started yet.",
      contest_minimum_deposit: "A minimum deposit of ${value} USD is required.",
    },
  },
  id: {
    contestName: "Nama Kontes",
    contestNamePlaceholder: "Masukkan nama kontes Anda.",
    contestNameSuccess: "Nama kontes berhasil diubah.",
    bannerContest: {
      title: "Segera Hadir: IUX Trade and Win",
      title2: "Bergabung IUX Trade and Win",
      desc: "Mulai pertandingan trading Anda dan bersaing untuk hadiah senilai $12,000!",
      button: "Bergabung sekarang",
    },
    popupContest: {
      title: "Bergabung \nIUX Trade and Win",
      desc: "Mulai pertandingan trading Anda dan bersaing \nuntuk hadiah senilai $12,000!",
      button: "Bergabung sekarang",
    },
    dashboardContest: {
      dashboard: "Dasbor",
      not_participate: "Tidak berpartisipasi",
      preparing: "Sedang mempersiapkan",
      participate: "Berpartisipasi",
      deposit: "Deposit",
      return: "Pengembalian",
      return_percent: "Pengembalian (%)",
      prize: "Hadiah",
      top_trade: "Perdagangan teratas",
      ranking: "Peringkat",
      rank: "Peringkat",
      competitors: "Pesaing",
      title_no_data: "Data tidak ditemukan.",
      desc_no_data: "Kontes belum diperbarui.",
      title_no_ranking: "Tidak ada peringkat.",
      desc_no_ranking: "Kontes belum dimulai.",
      contest_minimum_deposit:
        "Anda harus menyetor minimum ${value} USD terlebih dahulu",
    },
  },
  ms: {
    contestName: "Nama Kontes",
    contestNamePlaceholder: "Masukkan nama kontes Anda.",
    contestNameSuccess: "Nama kontes berhasil diubah.",
    bannerContest: {
      title: "Segera Hadir: IUX Trade and Win",
      title2: "Sertai IUX Trade and Win",
      desc: "Mulakan perlawanan perdagangan anda dan bersaing untuk hadiah bernilai $12,000!",
      button: "Sertai sekarang",
    },
    popupContest: {
      title: "Sertai \nIUX Trade and Win",
      desc: "Mulakan perlawanan perdagangan anda dan \nbersaing untuk hadiah bernilai $12,000!",
      button: "Sertai sekarang",
    },
    dashboardContest: {
      dashboard: "Papan pemuka",
      not_participate: "Tidak mengambil bahagian",
      preparing: "Bersedia",
      participate: "Menyertai",
      deposit: "Deposit",
      return: "Pulangan",
      return_percent: "Pulangan (%)",
      prize: "Hadiah",
      top_trade: "Perdagangan teratas",
      ranking: "Kedudukan",
      rank: "Kedudukan",
      competitors: "Pesaing",
      title_no_data: "Data tidak ditemui.",
      desc_no_data: "Peraduan belum dikemas kini.",
      title_no_ranking: "Tiada ranking.",
      desc_no_ranking: "Peraduan belum bermula lagi.",
      contest_minimum_deposit:
        "Anda perlu mendepositkan minimum ${value} USD terlebih dahulu",
    },
  },
  vi: {
    contestName: "Tên Kỳ Thi",
    contestNamePlaceholder: "Nhập tên kỳ thi của bạn.",
    contestNameSuccess: "Tên kỳ thi đã được cập nhật.",
    bannerContest: {
      title: "Sắp Ra Mắt: IUX Trade and Win",
      title2: "Tham Gia IUX Trade and Win",
      desc: "Bắt đầu trận giao dịch của bạn và tranh tài để giành giải thưởng trị giá $12,000!",
      button: "Tham gia ngay",
    },
    popupContest: {
      title: "Tham Gia \nIUX Trade and Win",
      desc: "Bắt đầu trận giao dịch của bạn và tranh tài để \ngiành giải thưởng trị giá $12,000!",
      button: "Tham gia ngay",
    },
    dashboardContest: {
      dashboard: "Bảng điều khiển",
      not_participate: "Không tham gia",
      preparing: "Đang chuẩn bị",
      participate: "Tham gia",
      deposit: "Gửi tiền",
      return: "Lợi tức",
      return_percent: "Lợi tức (%)",
      prize: "Giải thưởng",
      top_trade: "Thương mại hàng đầu",
      ranking: "Xếp hạng",
      rank: "Xếp hạng",
      competitors: "Đối thủ cạnh tranh",
      title_no_data: "Không tìm thấy dữ liệu.",
      desc_no_data: "Cuộc thi vẫn chưa được cập nhật.",
      title_no_ranking: "Không có thứ hạng.",
      desc_no_ranking: "Cuộc thi vẫn chưa bắt đầu.",
      contest_minimum_deposit: "Bạn phải gửi tối thiểu ${value} USD trước",
    },
  },
  es: {
    contestName: "Nombre del Concurso",
    contestNamePlaceholder: "Ingrese el nombre del concurso.",
    contestNameSuccess: "Nombre del concurso actualizado.",
    bannerContest: {
      title: "Luego: IUX Trade and Win",
      title2: "Únete IUX Trade and Win",
      desc: "¡Comienza tu competencia de trading y compite por premios de $12,000!",
      button: "Únete ahora",
    },
    popupContest: {
      title: "Únete \nIUX Trade and Win",
      desc: "¡Comienza tu competencia de trading y compite \npor premios de $12,000!",
      button: "Únete ahora",
    },
    dashboardContest: {
      dashboard: "Panel de control",
      not_participate: "No participar",
      preparing: "Preparando",
      participate: "Participar",
      deposit: "Depositar",
      return: "Retorno",
      return_percent: "Retorno (%)",
      prize: "Premio",
      top_trade: "Principales empresas",
      ranking: "Ranking",
      rank: "Ranking",
      competitors: "Competidores",
      title_no_data: "Datos no encontrados.",
      desc_no_data: "El concurso no se ha actualizado todavía.",
      title_no_ranking: "No hay ranking.",
      desc_no_ranking: "El concurso no ha comenzado todavía.",
      contest_minimum_deposit:
        "Tienes que depositar mínimo ${value} USD primero",
    },
  },
  zh: {
    contestName: "比赛名称",
    contestNamePlaceholder: "输入您的比赛名称。",
    contestNameSuccess: "比赛名称已更新。",
    bannerContest: {
      title: "即将推出: IUX Trade and Win",
      title2: "加入 IUX Trade and Win",
      desc: "开始您的交易比赛，争夺 $12,000 的奖品！",
      button: "立即加入",
    },
    popupContest: {
      title: "加入 \nIUX Trade and Win",
      desc: "开始您的交易比赛，争夺 $12,000 的奖品！",
      button: "立即加入",
    },
    dashboardContest: {
      dashboard: "仪表板",
      not_participate: "不参与",
      preparing: "准备中",
      participate: "参与",
      deposit: "存款",
      return: "回报",
      return_percent: "回报 (%)",
      prize: "奖品",
      top_trade: "顶级交易",
      ranking: "排名",
      rank: "排名",
      competitors: "竞争对手",
      title_no_data: "未找到数据。",
      desc_no_data: "比赛尚未更新。",
      title_no_ranking: "没有排名。",
      desc_no_ranking: "比赛尚未开始。",
      contest_minimum_deposit: "您必须先存入最低 ${value} 美元",
    },
  },
  ja: {
    contestName: "コンテスト名",
    contestNamePlaceholder: "コンテスト名を入力してください。",
    contestNameSuccess: "コンテスト名が更新されました。",
    bannerContest: {
      title: "近日公開: IUX Trade and Win",
      title2: "参加する IUX Trade and Win",
      desc: "トレードマッチを始めて、総額 $12,000 の賞品を目指して競い合いましょう！",
      button: "今すぐ参加",
    },
    popupContest: {
      title: "参加する \nIUX Trade and Win",
      desc: "トレードマッチを始めて、総額 $12,000 の賞品を\n目指して競い合いましょう！",
      button: "今すぐ参加",
    },
    dashboardContest: {
      dashboard: "ダッシュボード",
      not_participate: "参加しない",
      preparing: "準備中",
      participate: "参加する",
      deposit: "入金",
      return: "利益",
      return_percent: "利益 (%)",
      prize: "賞品",
      top_trade: "トップ トレード",
      ranking: "ランキング",
      rank: "ランキング",
      competitors: "競合他社",
      title_no_data: "データが見つかりません。",
      desc_no_data: "コンテストはまだ更新されていません。",
      title_no_ranking: "ランキングはありません。",
      desc_no_ranking: "コンテストはまだ開始されていません。",
      contest_minimum_deposit:
        "最低 ${value} 米ドルを最初に入金する必要があります",
    },
  },
  pt: {
    contestName: "Nome do Perfil",
    contestNamePlaceholder: "Digite seu nome de perfil",
    contestNameSuccess: "Nome do perfil atualizado.",
    bannerContest: {
      title: "Em breve: IUX Trade and Win",
      title2: "Participe do IUX Trade and Win",
      desc: "Inicie sua partida de trading e concorra a $12.000 em prêmios!",
      button: "Participar agora",
    },
    popupContest: {
      title: "Participe do \nIUX Trade and Win",
      desc: "Inicie sua partida de trading e concorra \na $12.000 em prêmios!",
      button: "Participar agora",
    },
    dashboardContest: {
      dashboard: "Painel",
      not_participate: "Não Participando",
      preparing: "Preparando",
      participate: "Participando",
      deposit: "Depósito",
      return: "Retornos",
      return_percent: "Retornos (%)",
      prize: "Prêmio",
      top_trade: "Melhores Trades",
      ranking: "Classificação",
      rank: "Posição",
      competitors: "Competidores",
      title_no_data: "Dados não encontrados.",
      desc_no_data: "O concurso ainda não foi atualizado.",
      title_no_ranking: "Sem classificação.",
      desc_no_ranking: "O concurso ainda não começou.",
      contest_minimum_deposit:
        "É necessário um depósito mínimo de ${value} USD.",
    },
  },
  lo: {},
  hi: {},
  ko: {},
  fil: {},
};
